import { AnimationEvent, useEffect, useState } from 'react';

import './Overlay.scss';

export enum OverlayActiveClass {
	FADED = 'faded',
	FADE_IN = 'fadeIn',
	FADE_OUT = 'fadeOut',
}

export type OverlayProps = { isVisible?: boolean };

const Overlay: React.FC<OverlayProps> = ({ isVisible = false }) => {
	const [activeClass, setActiveClass] = useState<OverlayActiveClass>(
		OverlayActiveClass.FADED
	);

	useEffect(() => {
		if (isVisible) {
			setActiveClass(OverlayActiveClass.FADE_IN);
		} else if (!isVisible && activeClass !== OverlayActiveClass.FADED) {
			setActiveClass(OverlayActiveClass.FADE_OUT);
		}
	}, [isVisible]);

	const animationFinished = (event: AnimationEvent): void => {
		if (event.animationName === 'fade-out') {
			setActiveClass(OverlayActiveClass.FADED);
		}
	};

	return (
		<div
			className={'blk-ac-overlay ' + activeClass}
			onAnimationEnd={animationFinished}
		></div>
	);
};

export default Overlay;
